import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import InputMask from 'react-input-mask';
import clsx from 'clsx';

import { AppDispatch } from '../../../redux/reducer/store';

import { reducerApplicationCreateIV } from '../../../redux/reducer/recruiting/reducers/reducerApplicationCreate';

import Select from '../../custom/select/select';

import styles from './recruiting.module.scss';
import '../../table/table.scss';
import { IUserOptions } from '../../../types/interfaces';

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const TableApplicationCreate: FC = () => {
	const dispatch = useDispatch<AppDispatch>();

	const { isOpenSidebar } = useSelector((state: IUserOptions) => state.user.user);

	const { selectedVacancy } = useSelector(
		(state: any) => state.recruiting.vacancyList
	);

  const { applicationCreateIV } = useSelector((state: any) => state.recruiting.applicationCreate)

	const selectChange = (event: {value: string, label: string}, name: string) => {
		const value = event.value;
		if (value === '') {
			const updatedInputValues = { ...applicationCreateIV };
			delete updatedInputValues[name];
			dispatch(reducerApplicationCreateIV(updatedInputValues));
		} else {
			dispatch(
				reducerApplicationCreateIV({
					...applicationCreateIV,
					[name]: name === 'project' ? { id: value } : value[0],
				})
			);
		}
	};

	const handleInputChange = (event: {target: { name: string, value: string }}) => {
		const { name, value } = event.target;

		if (value === '') {
			const updatedInputValues = { ...applicationCreateIV };
			delete updatedInputValues[name];

			dispatch(reducerApplicationCreateIV(updatedInputValues));
		} else {
			dispatch(
				reducerApplicationCreateIV({
					...applicationCreateIV,
					[name]: value,
				})
			);
		}
	};

  useEffect(() => {
    if(selectedVacancy) {
      dispatch(
				reducerApplicationCreateIV({
					...applicationCreateIV,
					vacancy: {id: selectedVacancy.vacancy.id, name: "string"}, applicantStatus: "NEW", gender: "Male" 
				})
			);
    }
  }, [applicationCreateIV, dispatch, selectedVacancy])

	return (
		<>
			<div
				className={clsx(
					JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
						isOpenSidebar &&
						'customerSingle__report_activeTable',
					!isOpenSidebar && 'customerSingle__report_closedTable',
					'vacancy_create_table'
				)}
			>
				<div className={styles.tableWrapper}>
					<div className={styles.midSectionWrapper}>
						<h1 className={styles.title}>Создание анкеты</h1>
					</div>

					<div className={styles.midSectionWrapper}>
						<div className={styles.halfBlock}>
							<div className={styles.vacancyBlock}>
								<span className='section__title'>Вакансия</span>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Название
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}></div>
										<div className={styles.subBlock__right__text}>
											{selectedVacancy && selectedVacancy.name}
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>Город</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<div className={styles.subBlock__right__text}>
												{selectedVacancy && selectedVacancy.cities}
											</div>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>Проект</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<div className={styles.subBlock__right__text}>
												{selectedVacancy && selectedVacancy.project}
											</div>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Список адресов
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<div className={styles.subBlock__right__text}>
												{selectedVacancy && selectedVacancy.addresses}
											</div>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Виртуальный супервайзер
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<div className={styles.subBlock__right__text}>
												{selectedVacancy && selectedVacancy.virtualSupervisors}
											</div>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Супервайзер
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<div className={styles.subBlock__right__text}>
												{selectedVacancy && selectedVacancy.supervisors}
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className={styles.vacancyBlock}>
								<span className='section__title'>Описание</span>
								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Статус кандидата
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<Select
												className={styles.filterSelect}
												propsChange={(event: {value: string, label: string}) =>
													selectChange(event, 'applicantStatus')
												}
												name='status'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Состояние кандидата
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<Select
												className={styles.filterSelect}
												propsChange={(event: {value: string, label: string}) =>
													selectChange(event, 'applicantCondition')
												}
												name='status'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Дата направления на стажировку
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<div className={styles.subBlock__right__text}>
											</div>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Комментарий к отказу
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<textarea
                        onChange={handleInputChange}
												className={styles.textarea}
												name='declineComment'
												id=''
												rows={10}
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Привязанный сотрудник
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<Select
												className={styles.filterSelect}
												name='sostaianue'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Желаемая должность
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<Select
												className={styles.filterSelect}
												name='desiredPosition'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>Фамилия</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<input
												onChange={handleInputChange}
												autoComplete='off'
												placeholder=' '
												name='lastName'
												type='text'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>Имя</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<input
												onChange={handleInputChange}
												autoComplete='off'
												placeholder=' '
												name='firstName'
												type='text'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Отчество
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<input
												onChange={handleInputChange}
												autoComplete='off'
												placeholder=' '
												name='middleName'
												type='text'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>Пол</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<Select
												className={styles.filterSelect}
												name='gender'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>Город</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<input
												onChange={handleInputChange}
												autoComplete='off'
												placeholder=' '
												name='cities'
												type='text'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Логин/Локация
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<input
												onChange={handleInputChange}
												autoComplete='off'
												placeholder=' '
												name='login'
												type='text'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Метро/район проживания
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<input
												onChange={handleInputChange}
												autoComplete='off'
												placeholder=' '
												name='subway'
												type='text'
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Комментарий
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<textarea
												className={styles.textarea}
                        onChange={handleInputChange}
												name='comment'
												id=''
												rows={10}
											/>
										</div>
									</div>
								</div>

								<div className={styles.subBlock}>
									<div className={styles.subBlock__left}>
										<span className={styles.subBlock__left__text}>
											Телефон соискателя
										</span>
									</div>
									<div className={styles.subBlock__right}>
										<div className={styles.filterInput}>
											<InputMask
                      onChange={handleInputChange}
                      name='phone'
												mask='+7 (999) 999-99-99'
												maskChar='_'
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default TableApplicationCreate;
